import { makeObservable, observable, action } from 'mobx'
import axios from "axios"
import config from "../config";
import qs from "querystring";
import { Redirect } from "react-router-dom";

const jwt = {};

class Auth {
	
	error = false
	user = ""
	loading = false
	token = false
	
	constructor() {
		makeObservable( this, {
			login: action,
			logout: action,
			user: observable,
			token: observable,
			loading: observable
		} )
	}
	
	async login( data ) {
		
		this.loading = true
		this.error = false
		
		await axios.post( `auth`, qs.stringify( data ) )
			.then( ( response ) => {
				
				this.token = response.data.token;
				
				localStorage.setItem( "token", response.data.token );
				localStorage.setItem( "id_point", response.data.user.id_point );
				localStorage.setItem( "id", response.data.user.id );
				localStorage.setItem( "id_user_group", response.data.user.id_user_group );
				
			} ).catch( ( error ) => {
				this.error = error.response.data
			} ).then( ( response ) => {
				this.loading = false
			} )
		
	}
	
	async try() {
		
		this.loading = true
		this.error = false
		
		await axios.post( `orders_complete` )
			.then( () => {
				this.token      = localStorage.getItem(`token`)
				this.id_point   = localStorage.getItem( `id_point` );
				this.id         = localStorage.getItem( `id` );
				this.id_user_group         = localStorage.getItem( `id_user_group` );
			})
			.catch( ( error ) => {
				if( window.location.pathname !== "/login" ){
					window.location = "/login"
				}
			} ).then( ( response ) => {
				this.loading = false
			} )
		
	}
	
	logout() {
		this.token = false;
		localStorage.clear();
	}
	
}


export default new Auth()
